module.exports = __webpack_public_path__ + "media/images/leadership_characteristics/bg-4-9a242d5265f2a24092b241472fd795c9.png";